import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=503a808a&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('503a808a')) {
      api.createRecord('503a808a', component.options)
    } else {
      api.reload('503a808a', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=503a808a&", function () {
      api.rerender('503a808a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4m2f5diDqYNAV/JS/comp/ImageCarousel.vue"
export default component.exports